import {
  SET_TOKEN,
  RESET_TOKEN,
  SET_USER_INFO,
  GET_USER_INFO,
  GET_USER_INFO_ERROR,
  GET_WORKSPACES,
  SET_WORKSPACES,
  SET_ACTIVE_WORKSPACE,
  SET_USER_TYPE,
  SET_PROFILE_INFO,
  SET_SUBSCRIPTION,
  SET_NOTIFICATION_SIDEBAR_COUNT
} from './types'

const initialState = {
  authToken: localStorage.getItem('authToken'),
  userId: null,
  name: null,
  email: null,
  position: null,
  userType: localStorage.getItem('userType'),
  userInfoIsLoading: true,
  workspacesIsLoading: false,
  getUserInfoError: null,
  avatar: null,
  workspaces: [],
  activeWorkspace: null,
  activeWorkspacePk: localStorage.getItem('activeWorkspace'),
  canSeeAll: false,
  canShareIn: false,
  canShareOut: false,
  receive_legal_updates: false,
  receive_requests: false,
  notificationCount: 0
}

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TOKEN:
      return {
        ...state,
        authToken: action.payload.authToken
      }
    case GET_USER_INFO:
      return {
        ...state,
        userInfoIsLoading: action.payload.userInfoIsLoading,
        getUserInfoError: null
      }
    case GET_WORKSPACES:
      return {
        ...state,
        workspacesIsLoading: action.payload && !!action.payload.workspacesIsLoading
      }
    case SET_USER_INFO:
      return {
        ...state,
        userInfoIsLoading: false,
        getUserInfoError: null,
        userId: action.payload.userId,
        name: action.payload.name,
        position: action.payload.position,
        userType: action.payload.userType,
        email: action.payload.email,
        avatar: action.payload.avatar,
        receive_legal_updates: action.payload.receive_legal_updates,
        receive_requests: action.payload.receive_requests,
        workspaces: action.payload.workspaces
      }
    case GET_USER_INFO_ERROR:
      return {
        ...state,
        userInfoIsLoading: false,
        getUserInfoError: action.payload.getUserInfoError
      }
    case SET_WORKSPACES:
      return {
        ...state,
        workspacesIsLoading: false,
        workspaces: action.payload.workspaces
      }
    case SET_ACTIVE_WORKSPACE:
      return {
        ...state,
        workspacesIsLoading: false,
        activeWorkspace: action.payload.activeWorkspace,
        activeWorkspacePk: action.payload.activeWorkspace.id,
        canSeeAll: action.payload.canSeeAll,
        canShareIn: action.payload.canShareIn,
        canShareOut: action.payload.canShareOut,
        notificationCount: action.payload.notificationCount
      }
    case SET_USER_TYPE:
      return {
        ...state,
        userType: action.payload.userType
      }
    case SET_PROFILE_INFO:
      return {
        ...state,
        name: action.payload.name,
        avatar: action.payload.avatar
      }
    case SET_SUBSCRIPTION:
      return {
        ...state,
        receive_legal_updates: action.payload.receive_legal_updates,
        receive_requests: action.payload.receive_requests
      }
    case SET_NOTIFICATION_SIDEBAR_COUNT:
      return {
        ...state,
        notificationCount: action.payload.notificationCount
      }
    case RESET_TOKEN:
      return initialState
    default:
      return state
  }
}

export default authReducer
